import type { OrderSummary } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { StatusBadge } from '@/shared/ui';
import { orderStatusTone } from '../model/status-tone';

interface OrderStatusBadgeProps {
  readonly order: Pick<
    OrderSummary,
    'status' | 'fulfillmentStatus' | 'pendingCancelRequest' | 'displayStatus'
  >;
}

/** 주문 상태 배지 — 표시 이름은 서버의 displayStatus, 색은 관리자 할 일 기준 톤. */
export const OrderStatusBadge = ({ order }: OrderStatusBadgeProps): ReactElement => (
  <StatusBadge tone={orderStatusTone(order)}>{order.displayStatus}</StatusBadge>
);
